import { Avatar, Box, Stack, Typography } from "@mui/material";
import React from "react";
import { SortableElement, sortableHandle } from "react-sortable-hoc";
import { Images } from "../../assets/common";
import LockIcon from "@mui/icons-material/Lock";
import { useHistory } from "react-router-dom";
import {
  fullName,
  getUserId,
  HMS,
  isOwnerId,
  truncate,
} from "../../constants/function";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DropMenu from "../../components/DropMenu";
import OutsideClickHandler from "react-outside-click-handler";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import "./index.scss";
import { useTranslation } from "react-i18next";
const DragHandle = sortableHandle(() => (
  <DragIndicatorIcon
    title={"Move"}
    sx={{ color: "#fff", cursor: "pointer", marginLeft: "20px" }}
  />
));
const MusicRow = SortableElement(
  ({
    index,
    musicIndex,
    m,
    playListId,
    handleTipClick,
    toggleMenu,
    play,
    musicLength,
    createdBy,
    sort,
    playlistNftd,
  }) => {
    const { t } = useTranslation("common");
    const [open, setOpen] = React.useState(false);
    const [selectedIndex, setSelectedIndex] = React.useState(null);
    const userId = getUserId();
    const history = useHistory();
    return (
      <Box className="_sortable_table_body_row">
        <Box
          className="_sortable_td"
          sx={{ width: playlistNftd ? "40% !important" : "30% !important" }}
        >
          <Stack direction="row" alignItems="center" spacing={2}>
            <Stack className="__music_thumb _cp">
              <Avatar
                src={
                  m["thumbnailImg"]["filePath"]
                    ? m["thumbnailImg"]["filePath"]
                    : Images.circle_music
                }
              />
              <img
                className="__play_hover"
                src={Images.play}
                alt="play"
                onClick={() => play(musicIndex)}
              />
            </Stack>
            <Stack direction="column">
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                sx={{ wordBreak: "break-word" }}
              >
                <Typography
                  variant="body1"
                  className="fs-16 capitalize"
                  title={m["title"].length > 50 ? m["title"] : ""}
                >
                  {m["title"] ? truncate(m["title"], 50) : ""}
                </Typography>
                {m["private"] ? (
                  <LockIcon
                    sx={{
                      width: "11px",
                      height: "11px",
                      padding: "2px",
                      color: "#989898",
                      backgroundColor: "#4E4E4E",
                    }}
                    className="__small_icon _lock_hover"
                  />
                ) : null}
              </Stack>
              <Stack
                direction="row"
                style={{
                  gap: "6px",
                  overflowX: "scroll",
                  // width: m.artistData.length > 2 ? "245px" : "",
                  maxWidth: "160px",
                }}
                className="scroll_display_musicCard res_artist"
              >
                {m.artistData ? (
                  m.artistData.length > 1 ? (
                    m.artistData.map((a, index) => (
                      <Typography
                        onClick={() => {
                          history.push(`/app/ArtistProfile/${a.uId}`);
                        }}
                        variant="body2"
                        className="fs-14 fade-text _cp"
                        key={index}
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {a?.displayArtistName}
                        {m.artistData.length - 1 == index ? "" : ","}
                      </Typography>
                    ))
                  ) : (
                    m.artistData.map((a, index) => (
                      <Typography
                        onClick={() => {
                          history.push(`/app/ArtistProfile/${a.uId}`);
                        }}
                        variant="body2"
                        className="fs-14 fade-text _cp"
                        key={index}
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {a?.displayArtistName}
                      </Typography>
                    ))
                  )
                ) : (
                  <Typography variant="body2" className="fs-14 fade-text">
                    {m["artist"] ? m["artist"] : ""}
                  </Typography>
                )}
              </Stack>
            </Stack>
          </Stack>
        </Box>

        <Box
          className="_sortable_td res"
          sx={{
            width: playlistNftd ? "25% !important" : "20% !important",
            display: "flex",
            alignItems: "center",
            justifyContent: "center !important",
          }}
        >
          <Box>
            {m["topTipperProfile"] &&
            m["topTipperProfile"]["filePath"] &&
            m["topTipperName"] ? (
              <Stack direction="row" spacing={2} alignItems="center">
                <Avatar
                  src={
                    m["topTipperProfile"]["filePath"]
                      ? m["topTipperProfile"]["filePath"]
                      : ""
                  }
                  sx={{ width: "30px", height: "30px" }}
                />
                <Typography
                  onClick={() =>
                    history.push(`/app/ArtistProfile/${m["topTipperId"]}`)
                  }
                  className="fs-14 text-white _cp"
                  sx={{
                    color: "#00C3FD",
                    marginLeft: "10px !important",
                  }}
                >
                  {m["topTipperName"] ? m["topTipperName"] : ""}
                </Typography>
              </Stack>
            ) : null}
          </Box>

          <Box display="flex">
            {!isOwnerId(m["topTipperId"]) && m["topTipperId"] ? (
              <img
                className="_cp"
                onClick={() => {
                  handleTipClick(m);
                }}
                style={{
                  width: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  marginLeft: "8px",
                }}
                src={Images.tip_hover_player}
                alt="tip"
              />
            ) : null}
          </Box>
        </Box>

        <Box
          className="text-center text-white fs-14 _sortable_td"
          sx={{
            width: playlistNftd ? "10% !important" : 0,
            whiteSpace: "nowrap",
          }}
        >
          {HMS(m["duration"])}
        </Box>
        <Box
          className="text-right _sortable_td"
          sx={{
            paddingRight: "20px !important",
            width: playlistNftd ? "25% !important" : 0,
          }}
        >
          <MoreVertIcon
            className="_cp"
            onClick={() => {
              setSelectedIndex(musicIndex);
              setOpen(!open);
            }}
            color="default"
          />
          {createdBy === userId && sort ? <DragHandle /> : null}
        </Box>
        {musicIndex === selectedIndex && open ? (
          <OutsideClickHandler onOutsideClick={() => setOpen(false)}>
            <DropMenu
              isLast={
                (musicIndex === musicLength - 1 ||
                  musicIndex === musicLength - 2 ||
                  musicIndex === musicLength - 3) &&
                musicLength > 3
                  ? "-90px !important"
                  : "40px"
              }
              right={"0px"}
              isMenu={open}
              actions={[
                { key: "m1", action: t("dropMenu.m1") },
                { key: "m2", action: t("dropMenu.m2") },
                { key: "m3", action: t("dropMenu.m3") },
                isOwnerId(createdBy)
                  ? { key: "m10", action: t("dropMenu.m10") }
                  : "",
                m["nftId"] ? { key: "m8", action: t("dropMenu.m8") } : "",
              ]}
              toggleMenu={(action) => {
                setOpen(false);
                toggleMenu(action, m._id, musicIndex);
              }}
            />
          </OutsideClickHandler>
        ) : null}
      </Box>
    );
  }
);

export default MusicRow;
